import { render } from "./EventInformation.vue?vue&type=template&id=15e19b99&scoped=true"
import script from "./EventInformation.vue?vue&type=script&lang=js"
export * from "./EventInformation.vue?vue&type=script&lang=js"

import "./EventInformation.vue?vue&type=style&index=0&id=15e19b99&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-15e19b99"

export default script